'use client';
import React, { useState } from 'react';
import {Card, MeterScoreFullDemo, MeterScoreNative, Heading} from '@ui';
import { withOptionalId } from '@lib/withOptionalId';
import { Section, Container } from '@layout';
import MarkupSnippet, { markupCopyLabels } from '../markup-snippet/MarkupSnippet';

interface MeterScoreDemoProps {
  sectionID?: string;
  classes?: string;
  containerId?: string;
  containerClasses?: string;
  isSpanish?: boolean;
}

const MeterScoreDemo: React.FC<MeterScoreDemoProps> = ({
  isSpanish = false,
  sectionID = '',
  classes = '',
  containerId,
  containerClasses,
}) => {
  const [value, setValue] = useState(72);
  const t = (en: string, es: string) => (isSpanish ? es : en);
  return (
    <Section {...withOptionalId(sectionID, 'meter')} className={classes}>
      <Container containerId={containerId} containerClasses={containerClasses}>
        <Heading as="h3">{t('Meter / Score', 'Medidor / Puntuacion')}</Heading>
        <p className='sub full'>
          {t(
            'Linear score with thresholds + native <meter> styling. Drag to preview values.',
            'Puntuacion lineal con umbrales + estilos nativos de <meter>. Arrastra para previsualizar valores.'
          )}
        </p>

        <Card className='score-card' id='scoreCard'>
          <MeterScoreFullDemo value={value} setValue={setValue} />
        </Card>

        <Card className='score-card' id='scoreCardNative'>
          <div className='row'>
            <label className='hint'>{t('Native meter', 'Medidor nativo')}</label>
            <MeterScoreNative value={value} setValue={setValue} />
          </div>
        </Card>
      <MarkupSnippet
          {...markupCopyLabels(isSpanish)}
          code={`<label for="score">Score</label>
<meter id="score" class="xmeter" min="0" max="100" low="50" high="75" optimum="100" value="72">72</meter>`}
        />
      </Container>
    </Section>
  );
};

export default MeterScoreDemo;
